import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_EXPIRING_WELLNESS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ExpiringWellnessClientsContent} from './ExpiringWellnessClientsContent';
import reportPayload from './reportPayload';

export const ExpiringWellnessClientsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Organization Clients with Expiring Wellness Credits')}
      description={tt(
        'description',
        'These Clients have Wellness Credits to be used on a future order - reach out to them today so that they have a chance to use them!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ExpiringWellnessClientsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.expiringWellnessClients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_EXPIRING_WELLNESS,
    popoverContentProps: {},
  }),
)(ExpiringWellnessClientsReport);
